import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { MediaClientContext, MediaClientProvider } from './MediaClientProvider';
export const withMediaClient = Component => ({
  mediaClientConfig,
  ...otherProps
}) => /*#__PURE__*/React.createElement(MediaClientContext.Consumer, null, value => value ? /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
  mediaClient: value
})) : /*#__PURE__*/React.createElement(MediaClientProvider, {
  clientConfig: mediaClientConfig
}, /*#__PURE__*/React.createElement(MediaClientContext.Consumer, null, client => /*#__PURE__*/React.createElement(Component, _extends({}, otherProps, {
  mediaClient: client
})))));